import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Las Cloud Functions viven en europe-west1 (la región por defecto us-central1
// no sirve aquí). Instanciamos una referencia con la región correcta.
const functions = getFunctions(getApp(), 'europe-west1');

/**
 * Envía una pregunta al asistente de soporte y devuelve la respuesta.
 * @param {string} mensaje Pregunta del usuario.
 * @param {Array<{role: string, content: string}>} historial Conversación
 *   previa (se envían los últimos turnos).
 * @returns {Promise<string>} Respuesta del asistente.
 */
export const preguntarAsistente = async (mensaje, historial = []) => {
  const fn = httpsCallable(functions, 'asistenteSoporte');
  const res = await fn({ mensaje, historial });
  const data = res && res.data ? res.data : {};
  return data.respuesta || '';
};
